/**
 * @flow
 * @relayHash 59d1b73eecbbed6df4325aa729af1c78
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateWidgetDataInput = {|
  userId: string,
  widgetId: string,
  data: string,
  clientMutationId?: ?string,
|};
export type UpdateWidgetDataMutationVariables = {|
  input: UpdateWidgetDataInput
|};
export type UpdateWidgetDataMutationResponse = {|
  +updateWidgetData: ?{|
    +widget: ?{|
      +data: ?string
    |}
  |}
|};
export type UpdateWidgetDataMutation = {|
  variables: UpdateWidgetDataMutationVariables,
  response: UpdateWidgetDataMutationResponse,
|};
*/


/*
mutation UpdateWidgetDataMutation(
  $input: UpdateWidgetDataInput!
) {
  updateWidgetData(input: $input) {
    widget {
      data
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateWidgetDataInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "data",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateWidgetDataMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateWidgetData",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateWidgetDataPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "widget",
            "storageKey": null,
            "args": null,
            "concreteType": "Widget",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateWidgetDataMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateWidgetData",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateWidgetDataPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "widget",
            "storageKey": null,
            "args": null,
            "concreteType": "Widget",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateWidgetDataMutation",
    "id": null,
    "text": "mutation UpdateWidgetDataMutation(\n  $input: UpdateWidgetDataInput!\n) {\n  updateWidgetData(input: $input) {\n    widget {\n      data\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '779999ee36248fb05842ed1964087919';
module.exports = node;
